/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_RewindInputs */

const en_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewind`)
};

const fr_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour rapide`)
};

const de_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückspulen`)
};

const it_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riavvolgi`)
};

const ru_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемотка назад`)
};

const es_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebobinar`)
};

const zh_cn2_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒带`)
};

const ja_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`巻き戻し`)
};

const hi_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवाइंड`)
};

const pt_pt2_options_pedal_action_rewind = /** @type {(inputs: Options_Pedal_Action_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceder`)
};

/**
* | output |
* | --- |
* | "Rewind" |
*
* @param {Options_Pedal_Action_RewindInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_rewind = /** @type {((inputs?: Options_Pedal_Action_RewindInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_RewindInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_action_rewind(inputs)
	if (locale === "de") return de_options_pedal_action_rewind(inputs)
	if (locale === "it") return it_options_pedal_action_rewind(inputs)
	if (locale === "ru") return ru_options_pedal_action_rewind(inputs)
	if (locale === "es") return es_options_pedal_action_rewind(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_action_rewind(inputs)
	if (locale === "ja") return ja_options_pedal_action_rewind(inputs)
	if (locale === "hi") return hi_options_pedal_action_rewind(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_action_rewind(inputs)
	return en_options_pedal_action_rewind(inputs)
});